/*
  extenders-facet-remove.js - bewust leeg. 14-10-2026 (C4S).

  sections/main-collection.liquid laadt dit bestand, maar het bestond niet
  (ook niet in de TAM-bron /t/45): elke collectiepagina gaf een 404. Het
  verwijderen van een filter heeft geen JavaScript nodig: de chips in
  snippets/applied-filters.liquid zijn gewone links naar url_to_remove.
  Dit lege module-bestand haalt de 404 weg zonder main-collection.liquid te
  hoeven herschrijven. Bij opruimen: de render-regel in main-collection
  weghalen en dit bestand verwijderen.
*/
export {};
